/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Billing_Cycle_WeeklyInputs */

const en_admin_resources_billing_cycle_weekly = /** @type {(inputs: Admin_Resources_Billing_Cycle_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly`)
};

const de_admin_resources_billing_cycle_weekly = /** @type {(inputs: Admin_Resources_Billing_Cycle_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wöchentlich`)
};

const es_admin_resources_billing_cycle_weekly = /** @type {(inputs: Admin_Resources_Billing_Cycle_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanalmente`)
};

const fr_admin_resources_billing_cycle_weekly = /** @type {(inputs: Admin_Resources_Billing_Cycle_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque semaine`)
};

const nl_admin_resources_billing_cycle_weekly = /** @type {(inputs: Admin_Resources_Billing_Cycle_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wekelijks`)
};

/** @type {(inputs: Admin_Resources_Billing_Cycle_WeeklyInputs) => LocalizedString} */
const it_admin_resources_billing_cycle_weekly = en_admin_resources_billing_cycle_weekly;

/** @type {(inputs: Admin_Resources_Billing_Cycle_WeeklyInputs) => LocalizedString} */
const pt_br2_admin_resources_billing_cycle_weekly = en_admin_resources_billing_cycle_weekly;

/** @type {(inputs: Admin_Resources_Billing_Cycle_WeeklyInputs) => LocalizedString} */
const pl_admin_resources_billing_cycle_weekly = en_admin_resources_billing_cycle_weekly;

/** @type {(inputs: Admin_Resources_Billing_Cycle_WeeklyInputs) => LocalizedString} */
const hu_admin_resources_billing_cycle_weekly = en_admin_resources_billing_cycle_weekly;

/** @type {(inputs: Admin_Resources_Billing_Cycle_WeeklyInputs) => LocalizedString} */
const ro_admin_resources_billing_cycle_weekly = en_admin_resources_billing_cycle_weekly;

/**
* | output |
* | --- |
* | "Weekly" |
*
* @param {Admin_Resources_Billing_Cycle_WeeklyInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_billing_cycle_weekly = /** @type {((inputs?: Admin_Resources_Billing_Cycle_WeeklyInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Billing_Cycle_WeeklyInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_billing_cycle_weekly(inputs)
	if (locale === "de") return de_admin_resources_billing_cycle_weekly(inputs)
	if (locale === "es") return es_admin_resources_billing_cycle_weekly(inputs)
	if (locale === "fr") return fr_admin_resources_billing_cycle_weekly(inputs)
	if (locale === "nl") return nl_admin_resources_billing_cycle_weekly(inputs)
	if (locale === "it") return it_admin_resources_billing_cycle_weekly(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_billing_cycle_weekly(inputs)
	if (locale === "pl") return pl_admin_resources_billing_cycle_weekly(inputs)
	if (locale === "hu") return hu_admin_resources_billing_cycle_weekly(inputs)
	return ro_admin_resources_billing_cycle_weekly(inputs)
});
export { admin_resources_billing_cycle_weekly as "admin.resources.billing_cycle_weekly" }